module.exports = __webpack_public_path__ + "static/media/warning.fbe40aa1.svg";